import { ILogger } from './logger.interface';
import { LogOptions } from './logger.types';

export class Logger implements ILogger {
  /** Логирует сообщение об ошибке типа "error"
   * @param message Сообщение об ошибке
   * @param options Опции, определяют что будет залогировано
   * @returns {void}
   *  */
  error(message: unknown, options: LogOptions = {}) {
    // eslint-disable-next-line no-console
    console.error(
      'Message: %O\nTags: %O\nContext: %O\n',
      { message },
      options.tags,
      options.context,
    );
  }
}
